import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

const link = createHttpLink({ uri: `${process.env.REACT_APP_API}/api`, fetch });

export const client = new ApolloClient({
  link,
  cache: new InMemoryCache({ addTypename: false }),
});